<h3 class="mb-0">{{ 'compare_measurements.title' | translate }}</h3>
<p class="mb-4">{{ 'compare_measurements.subtitle' | translate }}</p>

<p-divider></p-divider>

<p-panel [toggleable]="true" [(collapsed)]="setupCollapsed" styleClass="mb-3">
  <ng-template #header>
    <div class="flex items-center gap-2">
      <i class="fa-solid fa-sliders text-surface-500 dark:text-surface-400"></i>
      <span class="font-semibold text-surface-900 dark:text-surface-0">{{ 'compare_measurements.setup_title' | translate }}</span>
      @if (setupCollapsed && selectedMetas().length) {
        <span class="text-sm text-surface-500 dark:text-surface-400">· {{ 'compare_measurements.setup_summary' | translate: { measurements: selectedMetas().length, variables: selectedVariables().size } }}</span>
      }
    </div>
  </ng-template>
  <p-tree
    [value]="treeNodes"
    selectionMode="checkbox"
    [selection]="selectedNodes"
    (selectionChange)="onSelectionChange($event)"
    styleClass="w-full border-none mb-4"
  />

  @if (setupCatalog().length) {
    <h4 class="mb-2">{{ 'compare_measurements.variables_title' | translate }}</h4>
    @for (typeBlock of setupCatalog(); track typeBlock.type) {
      <div class="mb-3 rounded-lg border border-surface-200 dark:border-surface-700 p-3">
        <div class="flex items-center gap-2 mb-1">
          <i class="fa-solid fa-chart-line text-surface-500 dark:text-surface-400"></i>
          <span class="font-semibold text-surface-900 dark:text-surface-0">{{ 'measurement.types.' + typeBlock.type | translate }}</span>
          <span class="text-xs text-surface-500 dark:text-surface-400">({{ typeBlock.total }})</span>
        </div>
        @if (!typeBlock.supported) {
          <span class="text-sm text-surface-500 dark:text-surface-400">{{ 'compare_measurements.unsupported' | translate }}</span>
        } @else {
          @for (sec of typeBlock.sections; track sec.section) {
            <div class="text-sm font-medium text-surface-500 dark:text-surface-400 mt-2 mb-1">{{ sec.sectionLabelKey | translate }}</div>
            <div class="flex flex-wrap gap-x-4 gap-y-2">
              @for (v of sec.variables; track v.key) {
                <label class="flex items-center gap-2 cursor-pointer">
                  <p-checkbox
                    [binary]="true"
                    [ngModel]="isVariableSelected(typeBlock.type, v.key)"
                    (ngModelChange)="toggleVariable(typeBlock.type, v.key)" />
                  <span>{{ v.labelKey | translate }}</span>
                  @if (v.available < v.total) {
                    <span class="text-xs text-surface-500 dark:text-surface-400">({{ 'compare_measurements.coverage' | translate: { available: v.available, total: v.total } }})</span>
                  }
                </label>
              }
            </div>
          }
        }
      </div>
    }
  } @else {
    <p class="text-sm text-surface-500 dark:text-surface-400 mb-3">{{ 'compare_measurements.no_variables' | translate }}</p>
  }

  <div class="w-full flex justify-center my-3">
    <button pButton color="primary" type="button" class="w-full"
      [disabled]="!canCompare()"
      (click)="submit()">{{ 'compare_measurements.button' | translate }}</button>
  </div>
</p-panel>

@if (loadingChart()) {
  <div class="w-full flex justify-center my-3">
    <i class="fa-solid fa-spinner fa-spin text-2xl"></i>
  </div>
}

@if (!loadingChart() && hasLoaded()) {
  @if (filterRows().length) {
    <p-panel [header]="'compare_measurements.filters_title' | translate" [toggleable]="true" styleClass="my-3">
      @for (row of filterRows(); track row.measurementId + row.def.id) {
        <div class="flex flex-wrap items-center gap-3 mb-2">
          <span class="font-medium text-surface-900 dark:text-surface-0">{{ row.measurementName }}</span>
          <span class="text-sm text-surface-500 dark:text-surface-400">{{ row.def.labelKey | translate }}</span>
          <cosmos-toggle-filter
            [options]="row.def.options"
            [mode]="row.def.mode"
            [selected]="filterSelection(row.measurementId, row.def)"
            (selectedChange)="onFilterChange(row.measurementId, row.def.id, $event)" />
        </div>
      }
    </p-panel>
  }

  @for (typeBlock of layout(); track typeBlock.type) {
    <p-divider></p-divider>
    <h3>{{ 'measurement.types.' + typeBlock.type | translate }}</h3>
    @for (sec of typeBlock.sections; track sec.section) {
      <h4 class="mt-2 mb-2 text-surface-700 dark:text-surface-200">{{ sec.sectionLabelKey | translate }}</h4>
      <div class="grid grid-cols-1 gap-4">
        @for (chart of sec.charts; track chart.chartKey) {
          <p-card class="min-w-0">
            <ng-template #title>{{ chart.variable.labelKey | translate }}</ng-template>
            <ng-template #subtitle>{{ chart.variable.unit }}</ng-template>
            <div class="flex w-full min-w-0">
              <cosmos-multi-line-chart
                [dataObjects]="chart.dataObjects"
                [dataset]="chart.variable.key"
                [chartId]="'compare_' + chart.chartKey"
                [thresholdBands]="chart.variable.thresholdBands ?? null"
                [reorder]="true"
                [downloadAllowed]="true"
                [sameOriginAllowed]="true"
                [rangeSelector]="true"
                [overlay]="chart.overlay"
                [overlayOptions]="chart.overlayOptions"
                [overlayKey]="chart.overlay?.dataset ?? null"
                (overlayChange)="onOverlayChange(chart.chartKey, $event)">
              </cosmos-multi-line-chart>
            </div>
          </p-card>
        }
      </div>
    }
  }
  @if (!layout().length) {
    <p-card><div class="text-center p-4">{{ 'compare_measurements.no_data' | translate }}</div></p-card>
  }
}
